import { __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, ViewChild, Component, NgModule } from '@angular/core';
import { IonSlides, IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { CommonModule } from '@angular/common';

// @Component({
//   selector:"popover-info-text",
//   inputs: ['infoMessage'],
//   template: `
//     <p>
//       {{infoMessage}}
//     </p>
//   `,
// })
// export class PopInfoText {
//   constructor() { }
// }
let UiCBarInfoComponent = class UiCBarInfoComponent {
    constructor(
    // public popoverController: PopoverController
    ) {
        this.back = new EventEmitter();
        this.next = new EventEmitter();
        this.showingInfo = false;
    }
    ngOnInit() { }
    showInfo() {
        this.showingInfo = true;
    }
    hideInfo() {
        this.showingInfo = false;
    }
    // async presentPopover(ev: any) {
    //   const popover = await this.popoverController.create({
    //     component: PopInfoText,
    //     cssClass: 'popover-info-class',
    //     componentProps: {
    //       infoMessage: this.infoMessage
    //     },
    //     // translucent: true
    //   });
    //   return await popover.present();
    // }
    // dismissPopOver(){
    //   this.popoverController.dismiss()
    // }
    slideBack() {
        this.slides.slidePrev();
        this.back.emit();
    }
    slideNext() {
        this.slides.slideNext();
        this.next.emit();
    }
};
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCBarInfoComponent.prototype, "messages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCBarInfoComponent.prototype, "infoMessage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCBarInfoComponent.prototype, "back", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCBarInfoComponent.prototype, "next", void 0);
__decorate([
    ViewChild(IonSlides, { static: true }),
    __metadata("design:type", IonSlides)
], UiCBarInfoComponent.prototype, "slides", void 0);
UiCBarInfoComponent = __decorate([
    Component({
        selector: 'ui-c-bar-info',
        template: "<div class=\"bar-info\">\n  <ion-row class=\"row-info\">\n    <ion-col class=\"col-info-icon\" size=\"1\">\n      <ion-icon (mouseover)=\"showInfo()\" (mouseout)=\"hideInfo()\" class=\"icon info-icon\" name=\"information-circle-outline\"></ion-icon>\n      <!-- <div class=\"info-message\" *ngIf=\"showingInfo\">\n        <span>\n          {{infoMessage | wlpTranslate}}\n        </span>\n      </div> -->\n    </ion-col>\n    <ion-col size=\"9\">\n      <ion-slides pager=\"false\" #slides>\n        <div *ngIf=\"messages.length > 0; then thenBlock else elseBlock\"></div>\n        <ng-template #thenBlock>\n          <ion-slide class=\"slide-message\" *ngFor=\"let item of messages; let i = index\">\n            {{i+1}} - {{item.title}} {{item.date}}\n          </ion-slide>\n        </ng-template>\n        <ng-template #elseBlock>\n          <ion-slide class=\"slide-message\">\n            {{'DASHBOARD.NOTIFICATIONS.NO_NOTIFICATIONS' | wlpTranslate}}\n          </ion-slide>\n        </ng-template>\n      </ion-slides>\n    </ion-col>\n    <ion-col class=\"col-info-arrow\" size=\"2\">\n      <ion-icon (click)=\"slideBack()\" class=\"icon-arrow-info\" name=\"chevron-back-outline\"></ion-icon>\n      <ion-icon (click)=\"slideNext()\" class=\"icon-arrow-info\" name=\"chevron-forward-outline\"></ion-icon>\n    </ion-col>\n  </ion-row>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCBarInfoComponent);

let UiCBarInfoModule = class UiCBarInfoModule {
};
UiCBarInfoModule = __decorate([
    NgModule({
        declarations: [
            UiCBarInfoComponent
        ],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule
        ],
        exports: [UiCBarInfoComponent]
    })
], UiCBarInfoModule);

export { UiCBarInfoComponent, UiCBarInfoModule };
//# sourceMappingURL=wlp-ui-c-bar-info.js.map
